module.exports = [{
      plugin: require('/var/lib/jenkins/jobs/app-styleguide/workspace/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/lib/jenkins/jobs/app-styleguide/workspace/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
